<template>
    <layout class="home">

      <Title
        title="Transações Shipay"
        margin="large"
        :hasPrint="true"
      />

      <Table
        :tableData="tableData"
        :items="transactions"
        :pagination="false"
      >
        <template slot="form">
          <b-col sm="4">
            <b-row>
              <b-col sm="6">
                <InputDate
                  id="fromDate"
                  placeholder="Selecione um periodo"
                  v-model="form.date"
                />
              </b-col>
              <b-col sm="6">
                <Select
                  id="status"
                  placeholder="Status"
                  v-model="form.status"
                  :options="optionsStatus"
                />
              </b-col>
            </b-row>
          </b-col>
        </template>
      </Table>

  </layout>
</template>

<script>

import { mapActions } from 'vuex';

import { STATUS } from '@/modules/Fiscal/enums/Shipay';

import {
  Layout,
  Title,
  Table,
  TableData,
  Actions,
} from '@/components';

import {
  InputDate,
  Select,
} from '@/components/Form';

export default {
  name: 'ShipayTransaction',
  components: {
    Layout,
    Title,
    Table,
    InputDate,
    Select,
  },
  data() {
    return {
      transactions: [],
      form: {
        date: this.$moment(this.$moment().format('YYYY-MM-01')).toDate(),
        status: 'todos',
      },
    };
  },
  watch: {
    form: {
      handler() {
        this.getTransactions();
      },
      deep: true,
    },
  },
  async mounted() {
    this.getTransactions();
  },
  computed: {
    optionsStatus() {
      return [
        { value: 'todos', text: 'Todos' },
        ...(Object.entries(STATUS).map(([value, text]) => ({
          value,
          text,
        }))),
      ];
    },
    tableData() {
      const {
        Data,
        TABLE_CELL_ALIGN,
      } = TableData;

      const DataTable = new Data({
        select: true,
        panelActions: true,
        advancedFilters: true,
        titleMobile: (item) => item.description,
      });

      DataTable
        .addField({
          key: 'document',
          label: 'Nº nota',
          sortable: true,
          align: TABLE_CELL_ALIGN.center,
          width: 100,
        })
        .addField({
          key: 'orderId',
          label: 'Order ID',
        })
        .addField({
          key: 'status',
          label: 'Status',
          sortable: true,
          formatter: (value) => STATUS[value],
          width: 200,
          align: TABLE_CELL_ALIGN.center,
        })
        .addField({
          key: 'created',
          label: 'Data',
          sortable: true,
          formatter: (value) => this.$moment(value).format('DD/MM/YYYY'),
          align: TABLE_CELL_ALIGN.center,
        })
        .addField({
          key: 'total',
          label: 'Valor',
          formatter: (value) => (
            new Intl
              .NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
              .format(value)
          ),
          align: TABLE_CELL_ALIGN.right,
        })
        .addActions(Actions('cancel', (selected) => this.cancel(selected)))
        .addActions(Actions('consult', (selected) => this.consult(selected)));
      return DataTable;
    },
  },
  methods: {
    ...mapActions('application', ['setLoading']),
    onSearch() {
      this.getTransactions();
    },
    async consult(ids) {
      this.setLoading(true);
      const form = {
        orderIds: ids.reduce((all, { id }) => (
          id ? [...all, id] : all
        ), []),
      };

      try {
        const { data: { data } } = await this.$http.post('fiscal.get-shipayOrderStatus', form);
        const { status } = data;

        this.transactions = this.transactions.map((transaction) => ({
          ...transaction,
          status: status[transaction.id] || transaction.status,
        }));
      } catch (e) {
        this.$alert.error(e?.response?.data?.error_message);
      }

      this.setLoading(false);
    },
    async cancel(ids) {
      this.setLoading(true);
      const form = {
        orderIds: ids.reduce((all, { id }) => (
          id ? [...all, id] : all
        ), []),
      };

      try {
        const { data: { data } } = await this.$http.post('fiscal.post-shipayOrderCancel', form);
        const { status } = data;

        this.transactions = this.transactions.map((transaction) => ({
          ...transaction,
          status: status[transaction.id] || transaction.status,
        }));
      } catch (e) {
        this.$alert.error(e?.response?.data?.error_message);
      }

      this.setLoading(false);
    },
    async getTransactions() {
      this.setLoading(true);
      const form = {
        fromDate: this.$moment(this.form.date[0]).format('YYYY-MM-DD'),
        toDate: this.$moment(this.form.date[1]).format('YYYY-MM-DD'),
        status: this.form.status !== 'todos' ? this.form.status : null,
      };
      try {
        const { data: { data } } = await this.$http.post('fiscal.get-shipayTransaction', form);
        this.transactions = data;
      } catch (e) {
        this.$alert.error(e?.response?.data?.error_message || 'Erro ao carregar transações');
      }

      this.setLoading(false);
    },
  },
};
</script>
